


































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import LayoutModule from '../../store/layout';
import ConfigurationDrawer from '~/components/configuration/ConfigurationDrawer.vue';
import EnrollmentModule from '~/store/enrollment';
import DocumentUploadModule from '~/store/documentUpload';
@Component<Header>({
    components: {
        ConfigurationDrawer,
    },
})
export default class Header extends Vue {
    @Resolve
    public layout!: LayoutModule;

    @Resolve
    public enrollment!: EnrollmentModule;

    @Resolve
    public uploadModule!: DocumentUploadModule;

    public get headerLogoSrc() {
        if(this.$route.name ==='index' || this.$route.name === 'selection' || this.$route.name === 'reimbursement' ) {
            return this.$settings.url(this.$settings.NoImage);
        }
        if(localStorage.getItem('drugNamePath')==='alprolix' ) {
             return this.$settings.url(this.$settings.LogoAlprolix);
        }else if(localStorage.getItem('drugNamePath')==='eloctate') {
            return this.$settings.url(this.$settings.LogoEloctate);
        }
        else if(localStorage.getItem('drugNamePath')==='qfitlia') {
            return this.$settings.url(this.$settings.LogoQfitlia);
        }
        else if(localStorage.getItem('drugNamePath')==='altuviiio') {
            if(localStorage.getItem('enrollmentTypePatientOrHCP')==='HCP'){
                return  this.$settings.url(this.$settings.LogoAltuviiio);
            }
                return this.$settings.url(this.$settings.LogoAltuviiio);
            }
        else{
            return this.$settings.url(this.$settings.NoImage);
        }
        }


    public setHeaderStyle() {
        if(this.$route.name ==='index' || this.$route.name === 'selection' || this.$route.name === 'reimbursement' ){
            if(this.$vuetify.breakpoint.width<387) {
                return {
                    width:"190px",
                    height:"95%",
                    marginTop: "-10px",
                }
            }
            if(this.$vuetify.breakpoint.width<438) {
                return {
                    width:"200px",
                    height:"86%",
                    marginTop: "-10px",
                }
            }
            if(this.$vuetify.breakpoint.width<780) {
                return {
                    width:"250",
                    height:"93%",
                    marginTop: "-10px",
                }
            }
            if(this.$vuetify.breakpoint.width<1036){
                return {
                    width:"290",
                    height:"98%",
                    marginTop: "-10px",
                }
            }
            return {
                width:"255px",
                height:"90%",
                marginTop: "-10px",
            }
        }
        if(localStorage.getItem('drugNamePath')==='alprolix') {
            if(this.$vuetify.breakpoint.width<387) {
                return {
                    width:"180px",
                    height:"100%",
                    marginTop: "-10px",
                    position:"relative",
                    left:"0px",
                    top:"-5px"
                }
            }
            if(this.$vuetify.breakpoint.width<438) {
                return {
                    width:"220px",
                    height:"100%",
                    marginTop: "-10px",
                    position:"relative",
                    left:"0px",
                    top:"-5px"
                }
            }
            if(this.$vuetify.breakpoint.width<780) {
                return {
                    width:"250px",
                    height:"100%",
                    marginTop: "-10px",
                    position:"relative",
                    left:"-9px",
                    top:"-10px"
                }
            }
            if(this.$vuetify.breakpoint.width<1036){
                return {
                    width:"300px",
                    height:"100%",
                    marginTop: "-10px",
                }
            }
            return {
                width:"300px",
                height:"75%",
                marginTop: "10px",
                position:"relative",
                left:"-9px",
                top:"-10px"
            }
        }
        else if(localStorage.getItem('drugNamePath')==='eloctate') {
            if(this.$vuetify.breakpoint.width<387) {
                return {
                    width:"180px",
                    height:"100%",
                    position:"relative",
                    left:"0px",
                    top:"-10px"
                }
            }
            if(this.$vuetify.breakpoint.width<438) {
                return {
                    width:"220px",
                    height:"100%",
                    position:"relative",
                    left:"0px",
                    top:"-10px"
                }
            }
            if(this.$vuetify.breakpoint.width<780) {
                return {
                    width:"270px",
                    height:"100%",
                    marginBottom: "10px",
                    marginTop:"0px",
                    position:"relative",
                    left:"-9px",
                    top:"-10px"
                }
            }
            if(this.$vuetify.breakpoint.width<1036) {
                return {
                    width:"320px",
                    height:"100%",
                    position:"relative",
                    left:"-9px",
                    top:"-15px"
                }
            }
            return {
                    width:"300px",
                    height:"74%",
                    position:"relative",
                    left:"-9px",
                    top:"-10px"
            }
        }
        else  {
            if(this.$vuetify.breakpoint.width<387) {
                return {
                    width:"160px",
                    height:"100%",
                    position:"relative",
                    top:"-10px",
                }
            }
            if(this.$vuetify.breakpoint.width<438) {
                return {
                    width:"200px",
                    height:"100%",
                    position:"relative",
                    top:"-15px",
                    left:"5px"
                }
            }
            if(this.$vuetify.breakpoint.width<780) {
                return {
                    width:"250px",
                    height:"100%",
                    position:"relative",
                    top:"-20px"
                }
            }
            if(this.$vuetify.breakpoint.width<1036){
                return {
                    width:"300px",
                    height:"100%",
                    marginTop:"-15px",
                }
            }
            return {
                width:"300px",
                height:"80%",
                position:"relative",
                marginTop:"45px",
                top:"-30px"
            }
        }
        // else{
        //     if(this.$vuetify.breakpoint.width<387) {
        //                     return {
        //                         width:"160px",
        //                         height:"100%",
        //                         marginTop: "-10px",
        //                     }
        //                 }
        //                 if(this.$vuetify.breakpoint.width<438) {
        //                     return {
        //                         width:"200px",
        //                         height:"100%",
        //                         marginTop: "-10px",
        //                     }
        //                 }
        //                 if(this.$vuetify.breakpoint.width<780) {
        //                     return {
        //                         width:"250px",
        //                         height:"100%",
        //                         marginTop: "-10px",
        //                     }
        //                 }
        //                 if(this.$vuetify.breakpoint.width<1036){
        //                     return {
        //                         width:"300px",
        //                         height:"100%",
        //                         marginTop: "-10px",
        //                     }
        //                 }
        //                 return {
        //                     width:"255px",
        //                     height:"100%",
        //                     marginTop: "-10px",
        //                 }
        // }
    }

    public setHeaderLogoDataTest(){
        if(this.$route.name ==='index' || this.$route.name === 'selection' || this.$route.name === 'reimbursement' ){
            return "img_header_logo"
        }
        else if(localStorage.getItem('drugNamePath')==='alprolix') {
                return "alprolix_img_header_logo"
            }
            else if(localStorage.getItem('drugNamePath')==='eloctate') {
                return "eloctate_img_header_logo"
            }
            else if(localStorage.getItem('drugNamePath')==='qfitlia') {
                return "qfitlia_img_header_logo"
            }
            else{
                return "sarclisa_img_header_logo"
            }
    }

    public get isAbsolute() {
        return this.layout.configuration.logoPosition !== 'start';
    }

    public get isScrolling() {
        return this.layout.configuration.headerStyle === 'scrolling';
    }
    public get brkPoints() {
        return {
            'brk-xs': this.$vuetify.breakpoint.xs,
            'brk-xs-only': this.$vuetify.breakpoint.xsOnly,
            'brk-sm': this.$vuetify.breakpoint.sm,
            'brk-sm-only': this.$vuetify.breakpoint.smOnly,
            'brk-sm-and-down': this.$vuetify.breakpoint.smAndDown,
            'brk-sm-and-up': this.$vuetify.breakpoint.smAndUp,
            'brk-md': this.$vuetify.breakpoint.md,
            'brk-md-only': this.$vuetify.breakpoint.mdOnly,
            'brk-md-and-down': this.$vuetify.breakpoint.mdAndDown,
            'brk-md-and-up': this.$vuetify.breakpoint.mdAndUp,
            'brk-lg': this.$vuetify.breakpoint.lg,
            'brk-lg-only': this.$vuetify.breakpoint.lgOnly,
            'brk-lg-and-down': this.$vuetify.breakpoint.lgAndDown,
            'brk-lg-and-up': this.$vuetify.breakpoint.lgAndUp,
            'brk-xl': this.$vuetify.breakpoint.xl,
            'brk-xl-only': this.$vuetify.breakpoint.xlOnly,
        };
    }

    handleClick() {
        this.$vuetify.goTo('#main-footer', {
            duration: 1000,
            easing: 'easeInOutCubic',
            offset: 70,
        });
    }
    logoClick() {
        // Clearstore after delay of 200ms to avoid conflict with any pages' beforeDestroy logic.
        const obj = this;
        setTimeout(() => {
            obj.enrollment.clearStore();
            this.uploadModule.clearStore();
            this.uploadModule.setIsFreshStart(true);
        }, 70);
    }
}
